<template>
    <div class="prospective-patent-analysis-comps d-flex flex-column w-full h-full">
        <AonAlertBox v-if="summaryError" is-contextual :title="summaryError" type="notification" />
        <template v-else>
            <p>
                We've compiled a list of potential competitors based on the identified product
                area(s) within your innovation.
            </p>
            <BenchmarkingCompetitorTable
                class="mt-md w-100"
                ref="competitorTableRef"
                :table-data="competitorSummaryData"
                :loading="compSummaryLoading"
                :tech-area-ids="playbookStore.conceptPks"
                :include-optional-columns="['conceptNames']"
                patent-list-type="conceptDirect"
                noRowsText="No competitors identified"
            />
        </template>
    </div>
</template>

<script setup>
import BenchmarkingCompetitorTable from '@/components/company/tabs/benchmarking/components/BenchmarkingCompetitorTable.vue'
import { computed } from 'vue'
import { useProspectivePatentPlaybookStore } from '@/stores/prospectivePatentPlaybook.js'
import AonAlertBox from '@moatmetrics/armory/src/components/base/AonAlertBox.vue'

const playbookStore = useProspectivePatentPlaybookStore()

const compSummaryLoading = computed(
    () => playbookStore.loadingStates?.competitorSummary?.loading ?? true
)
const competitorSummaryData = computed(() => playbookStore.competitorSummaryData)
const summaryError = computed(() => playbookStore.loadingStates?.competitorSummary?.error)
</script>

<style scoped lang="scss"></style>
